export default {"src":"/_next/static/media/anchor.ccdb43ba.svg","height":100,"width":100};